import { TTagsManager } from '../../types/tag';
import { getTermsValue, isSuburban, offerTypeFromJsonQuery, resetTerms, setTerms } from '../../../../JsonQuery';
import { HOUSE_MATERIAL_MAP_VALUE_TO_LABEL } from './constants';
import { createTagValue } from '../../utils/createTagValue';

const ID = 'houseMaterial' as const;

export const houseMaterialTagsManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const houseMaterials = getTermsValue('house_material')(jsonQuery);

    if (houseMaterials === null) {
      return null;
    }

    const offerType = offerTypeFromJsonQuery(jsonQuery);
    const label = isSuburban(offerType) ? 'Материал дома' : 'Тип дома';

    return houseMaterials.map(houseMaterial => ({
      label: `${label}: ${HOUSE_MATERIAL_MAP_VALUE_TO_LABEL[houseMaterial]}`,
      value: createTagValue(ID, houseMaterial.toString()),
    }));
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery, removingTagValue }) => {
    const houseMaterials = getTermsValue('house_material')(jsonQuery);

    if (houseMaterials === null) {
      return jsonQuery;
    }

    const nextHouseMaterials = houseMaterials.filter(houseMaterial => String(houseMaterial) !== removingTagValue);

    return nextHouseMaterials.length
      ? setTerms('house_material')(jsonQuery)(nextHouseMaterials)
      : resetTerms(['house_material'])(jsonQuery);
  },
};
